import { useState } from 'react';

import Button from '@breeze-platform-ui/button';
import { Int24Success } from '@breeze-platform-ui/iconsPack';

type Props = {
  link: string;
};

export const OrderLink = ({ link }: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(link);
    setIsCopied(true);
  };
  const handleCopyBlur = () => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 200);
    }
  };

  return (
    <div className="m-8 min-w-[436px] justify-center">
      <h4 className="mt-0 mb-1 font-heading text-2xl font-bold">
        Order added!
      </h4>
      <p className="mb-7 font-body text-base">
        Send the&nbsp;link to&nbsp;the&nbsp;customer to&nbsp;continue
        the&nbsp;application
      </p>
      <div
        className={`
          box-border flex items-center justify-between gap-6 rounded-[20px]
          bg-[#ECF1F7] p-5
        `}
      >
        <div
          className={`
            max-w-[300px] overflow-hidden font-body text-lg font-medium
            text-ellipsis whitespace-nowrap
          `}
        >
          {link}
        </div>
        <div className="w-[156px]">
          {isCopied ? (
            <div
              onBlur={handleCopyBlur}
              onMouseOut={handleCopyBlur}
              className={`
                box-border flex h-[58px] w-full cursor-default items-center
                gap-2 rounded-lg border border-solid border-[#0B92D3D] px-[35px]
                pt-[15px] pb-[14px] font-body text-[15px] text-[#00A127]
              `}
            >
              <Int24Success theme="green" /> Copied
            </div>
          ) : (
            <Button size="l" wide onClick={handleCopyClick}>
              Copy
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
